import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
import "./ApplicationManagement.css";
import NavigationBar from "../../Components/NavigationBar";

export default function Apc() {
  const [applications, setApplications] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
  const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL || 'http://localhost:5000/uploads';

  // Fetch applications from the backend
  useEffect(() => {
    fetch(`${API_BASE_URL}/getShortlistedAPCApplications`)
      .then((response) => response.json())
      .then((data) => {
        console.log("Fetched Data:", data);
        if (Array.isArray(data)) {
          setApplications(data);
        } else {
          console.error("API did not return an array:", data);
        }
      })
      .catch((error) => console.error("Error fetching applications:", error));
  }, [API_BASE_URL]);

  // Generate years from 2024 to current year
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 2024 + 1 },
    (_, i) => 2024 + i
  );

  // Filter applications based on selected year
  const filteredApplications = applications.filter((app) => {
    const matchesYear = selectedYear
      ? new Date(app.SubmittedDate).getFullYear().toString() === selectedYear
      : true;
    return matchesYear;
  });

  return (
    <div>
      <NavigationBar />
      <h1 className="page-name">Request Payment (APC)</h1>
      <div style={{ margin: "20px 0", display: "flex", gap: "20px", fontWeight: "bold" }}>
        <div>
          <label htmlFor="yearFilter">Filter by Year: </label>
          <select
            id="yearFilter"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            style={{
              padding: "5px",
              marginLeft: "10px",
              minWidth: "100px",
              color: "#000",
              backgroundColor: "#fff",
              border: "1px solid #ccc",
            }}
          >
            <option value="">Select Year</option>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>
      <Table
        striped
        bordered
        hover
        style={{
          marginTop: "20px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        }}
      >
        <thead>
          <tr>
            <th>Applicant Name</th>
            <th>Application Id</th>
            <th>Award Type</th>
            <th>Submitted Date</th>
            <th>Status</th>
            <th>Payment Request</th>
            <th>Download Payment Documents</th>
            <th>Application</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(filteredApplications) &&
            filteredApplications.map((app) => (
              <tr key={app.Application_Id}>
                <td>{app.Applicant_Name || app.Name}</td>
                <td>{app.Application_Id}</td>
                <td>{app.Award_Type}</td>
                <td>{app.SubmittedDate}</td>
                <td>{app.Status}</td>
                <td>
                  <button
                    className="View_Button"
                    style={{
                      backgroundColor:
                        (app.Payment_Request ?? 0) === 1 ? "#007bff" : "#052659",
                      color: "white",
                      border: `2px solid ${
                        (app.Payment_Request ?? 0) === 1 ? "#007bff" : "#052659"
                      }`,
                    }}
                    onClick={() => {
                      console.log("App object:", app);
                      console.log("Navigating with:", {
                        applicationId: app.Application_Id,
                        awardType: app.Award_Type,
                        name: app.Applicant_Name || app.Name,
                        email: app.Email,
                      });
                      navigate("/sendemailapplicant", {
                        state: {
                          applicationId: app.Application_Id,
                          awardType: app.Award_Type,
                          name: app.Applicant_Name || app.Name,
                          email: app.Email,
                        },
                      });
                    }}
                  >
                    {(app.Payment_Request ?? 0) === 1 ? "Sent" : "Send Email"}
                  </button>
                </td>
                <td>
                  {(app.Payment_Receipt_Receive ?? 0) === 1 ? (
                    <button
                      className="View_Button"
                      onClick={() => {
                        const fileName = `${app.Application_Id}_PaymentReceipt.pdf`;
                        const fileUrl = `${FILE_BASE_URL}/api/Uploads/APCPaymentReceipt/${fileName}`;
                        window.open(fileUrl, "_blank");
                      }}
                    >
                      Download
                    </button>
                  ) : (
                    <span style={{ color: "gray" }}>Not available</span>
                  )}
                </td>
                <td>
                  <button
                    className="View_Button"
                    onClick={() => {
                      const formattedAwardType = app.Award_Type.replace(
                        /\s+/g,
                        "_"
                      );
                      const fileName = `${app.Application_Id}_${formattedAwardType}.pdf`;
                      const fileUrl = `${FILE_BASE_URL}/api/Uploads/ApplicationForms/${fileName}`;
                      window.open(fileUrl, "_blank");
                    }}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
}